export const ProfileEndpoint = {
  get: `profile`,
  patch: `profile`
}
